import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class UserAuditFeedbackService extends BaseService {
  constructor() {
    super(constants.GET_USER_AUDIT_FEEDBACK_DATA, 'userAuditFeedbackStatus');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { requestId } = payload;
    let finalPayload = {};
    finalPayload = _.omit(payload, ['requestId']);
    finalPayload = _.omit(finalPayload, ['tenantId']);
    return this.getClient('aiadmin').post(`/userfeedback/${requestId}`, finalPayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('userAuditFeedback').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('userAuditFeedback').resetStoreValues();
  }
}
